import React,{ useEffect, useState,useRef } from 'react';
import { } from 'react-weui';
import { dirPlayEnd } from '@/services/course';
import styles from './styles.scss';
import { history } from 'umi';

import { Tabs ,Toast} from 'antd-mobile';
import TabDetail from './components/TabDetail';
import TabDirectory from './components/TabDirectory';
import TabComment from './components/TabComment';

import { Player } from 'video-react';
import 'video-react/dist/video-react.css';

export default (props) => {
  const { course } = props;

  const [tabs,setTabs] = useState([
    { title: '详情' },
    { title: '目录' },
    { title: '评论' },
  ]);
  const [page, setPage] = useState(1);
  const [playDir,setPlayDir] = useState(null);
  const [isPlay,setIsPlay] = useState(false);



  const videoRef = useRef();
  const tabDirRef = useRef();


  function playEnd() {
    dirPlayEnd({id:playDir.id}).then(res =>{
      console.log(res);
    });

    setIsPlay(false);
  }


  return (
    <div className={styles.box}>
      {isPlay ?
        <div className={styles.headerBox} >
          <video ref={videoRef}
                 className={styles.video}
                 controls="controls"
                 onEnded={()=> {
                   setIsPlay(false);
                   playEnd();
                 }}>
            <source src={playDir.playAddress} type="video/mp4"/>
              您的浏览器不支持HTML5视频
          </video>
        </div>
        :
        <div className={styles.headerBox} >
          <img className={styles.cover} src={course.image} alt=''/>
          <img className={styles.playIcon} src={require('@/assets/ic_play.png')}
               onClick={()=>{
                 tabDirRef.current.defaultPlay();
               }}/>
        </div>}


      <Tabs
        tabs={tabs}
        initialPage={1} page={page}
        tabBarActiveTextColor={'#333333'}
        tabBarInactiveTextColor={'#888888'}
        tabBarUnderlineStyle={{ backgroundColor: 'transparent', height: '2' }}
        onChange={(tab, index) => {
          setPage(index)
        }}
        onTabClick={(tab, index) => {
          setPage(index)
        }}
      >
        <TabDetail course={course} goComment={() => {
          setPage(2);
        }}/>

        <TabDirectory ref={tabDirRef} course={course}
                      playDir={(dir) => {
                        setPlayDir(dir);
                        setIsPlay(true);

                        videoRef.current.load();
                        videoRef.current.play();
                      }}
        />


        <TabComment course={course} getCommentCount={(count) => {
          setTabs([
            { title: '详情' },
            { title: '目录' },
            { title: '评论' + (count > 0 ? '('+ count+')' : '') },
          ])
        }}/>

      </Tabs>

    </div>
  )


}

